import clsx from 'clsx';

import { DisplayMoney } from '@tock/money';
import { Typography } from 'omakase';
import BaseComponent from '@tock/shared/components/BaseComponent';
import DisplayPercentage from '@tock/shared/components/number/DisplayPercentage';

interface Props {
  selectedGratuityRate: number;
  gratuityOption: number;
  baseAmount: number;
  'data-testid'?: string;
  onClick(): void;
}

export default class GratuityOption extends BaseComponent<Props> {
  render() {
    const { selectedGratuityRate, gratuityOption, baseAmount, onClick } = this.props;
    return (
      <button
        className={clsx('Receipt-gratuityButton', {
          'is-selected': selectedGratuityRate === gratuityOption,
        })}
        aria-pressed={selectedGratuityRate === gratuityOption}
        onClick={onClick}
        data-testid={this.props['data-testid']}
      >
        <span className="Receipt-gratuityRate" data-testid={this.props['data-testid'] + '-percent'}>
          <Typography color="inherit" component="span" variant="body02">
            {gratuityOption === 0 ? (
              'No gratuity'
            ) : (
              <DisplayPercentage value={gratuityOption / 100.0} />
            )}
          </Typography>
        </span>
        {gratuityOption > 0 && (
          <span
            className="Receipt-gratuityAmount"
            data-testid={this.props['data-testid'] + '-amout'}
          >
            <Typography color="inherit" component="span" variant="body02">
              (<DisplayMoney amount={Math.round((gratuityOption / 100.0) * baseAmount)} />)
            </Typography>
          </span>
        )}
      </button>
    );
  }
}
